module.exports = __webpack_public_path__ + "static/img/modernWeb194.9fd1b98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/modernWeb19/modernWeb194.jpg
// module id = 118V
// module chunks = 1